import React from 'react';

const Footer = () => (
  <footer className="bg-gray-800 py-4 mt-8">
    <div className="container mx-auto px-4 text-center">
      <p>&copy; 2024 ID Master. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;